import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,           // 30s — PLM data doesn't change every second
      gcTime: 5 * 60 * 1000,      // 5min garbage collection
      retry: 1,
      refetchOnWindowFocus: true,
      placeholderData: (prev: unknown) => prev, // keep previous data during refetch
    },
    mutations: {
      retry: 0,
    },
  },
});
